import { render, staticRenderFns } from "./order_magor.vue?vue&type=template&id=9a086db0&scoped=true&"
import script from "./order_magor.vue?vue&type=script&lang=js&"
export * from "./order_magor.vue?vue&type=script&lang=js&"
import style0 from "./order_magor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order_magor.vue?vue&type=style&index=1&id=9a086db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a086db0",
  null
  
)

export default component.exports